import BaseModel from 'src/model/base.model';
import CartModel from 'src/model/cart.model';

export class CheckoutModel extends BaseModel {
  public checkoutCode: number;
  public cart: CartModel;
  public subtotal: string;
  public tax: string;
  public total: string;
  public defaultMOT: string;
  public termsOfDelivery: string;
  public softCreditHold: boolean;
  public allowedUserForExtraField: any;
}

export default CheckoutModel;
